// src/admin/pages/Dashboard/AdminDashboard.js
import React from "react";

export default function AdminDashboard() {
  return (
    <div>
      <h1>AI assistant</h1>
      <p>Pagina in costruzione. Il tuo assistente virtuale sarà presto disponibile</p>
    </div>
  );
}
